import React from 'react';
import PropTypes from 'prop-types';

// Hooks
import useLocaleOptions from 'hooks/use-locale-options';

// Utils
import bemify from 'utils/bemify';

// Components
import Button from 'components/button';
import Icon from 'components/icon';
import Image from 'components/image';
import Select from 'components/select';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);


const Header = ({
  className = null,
  displayLocaleSelector = false,
  onMoreInfoButtonClick = () => {},
  onSelectedLocaleChange = () => {},
  restaurantInfo,
  selectedLocale = null,
  translations
}) => {
  const scheduleText = restaurantInfo.isOpen ? translations.open : translations.closed;

  const localeOptions = useLocaleOptions();

  // Methods
  const handleSelectedLocaleChange = (newValue) => {
    onSelectedLocaleChange(newValue);
  };

  return (
    <section className={`${styles.header}${className ? ` ${className}` : ''}`}>
      {!!restaurantInfo.coverPhotoUrl && (
        <div className={styles.header__cover}>
          {!!restaurantInfo.coverPhotoUrl && (
            <div className={styles.header__imageWrapper}>
              <Image
                alt={translations.coverPhotoAlt}
                layout="fill"
                objectFit="cover"
                sizes="(min-width: 1440px) 1400px, 100vw"
                src={restaurantInfo.coverPhotoUrl}
              />
            </div>
          )}
        </div>
      )}
      {!!displayLocaleSelector && (
        <div className={styles.header__localeSelector}>
          <Select
            native
            options={localeOptions}
            rounded
            selectedOption={selectedLocale}
            onChange={handleSelectedLocaleChange}
          />
        </div>
      )}
      <div className={styles.header__info}>
        {!!restaurantInfo.logoUrl && (
          <div className={`${styles.header__avatarImage}${
            restaurantInfo.coverPhotoUrl ? ` ${styles.header__avatarImage_negativeTopMargin}` : ''}`}
          >
            <Image
              alt={translations.logoAlt}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              sizes="70px"
              src={restaurantInfo.logoUrl}
            />
          </div>
        )}
        <div className={styles.header__textWrapper}>
          <h2
            className={styles.header__title}
            title={restaurantInfo.name}
          >
            {restaurantInfo.name}
          </h2>
          <div className={styles.header__subtitleItems}>
            <div className={styles.header__category}>
              {restaurantInfo.category}
            </div>
            <div className={`${styles.header__subtitleItemDividerEllipse} d-none d-md-flex`} />
            <div className={styles.header__scheduleTime}>
              <Icon
                className={styles.header__scheduleTimeIcon}
                name="clock"
              />
              <div
                className={styles.header__scheduleTimeText}
                title={scheduleText}
              >
                {scheduleText}
              </div>
            </div>
            <div className={`${styles.header__subtitleItemDividerEllipse} d-none d-md-flex`} />
            <Button
              className={styles.header__moreInfoButton}
              text={translations.information}
              textWeight="regular"
              theme="unstyled"
              onClick={onMoreInfoButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  displayLocaleSelector: PropTypes.bool,
  onMoreInfoButtonClick: PropTypes.func,
  onSelectedLocaleChange: PropTypes.func,
  restaurantInfo: PropTypes.shape({
    category: PropTypes.string.isRequired,
    coverPhotoUrl: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    logoUrl: PropTypes.string,
    name: PropTypes.string.isRequired
  }).isRequired,
  selectedLocale: PropTypes.string,
  translations: PropTypes.shape({
    closed: PropTypes.string.isRequired,
    coverPhotoAlt: PropTypes.string.isRequired,
    information: PropTypes.string.isRequired,
    logoAlt: PropTypes.string.isRequired,
    open: PropTypes.string.isRequired
  }).isRequired
};

export default Header;
